import type { BrowserInfo } from "../types";

export function collectBrowserInfo(): BrowserInfo {
  const nav = window.navigator;
  // Round all pixel dimensions: on mobile (device-pixel-ratio scaling,
  // pinch-zoom, the dynamic viewport on iOS/Android) window.innerWidth/Height
  // and screen.width/height can be FRACTIONAL (e.g. 412.7). The server schema
  // requires integers, so an un-rounded value gets rejected as "Invalid input"
  // — which is exactly the Android Chrome failure. Round here at the source.
  return {
    userAgent: nav.userAgent.slice(0, 1024),
    language: nav.language,
    platform: nav.platform,
    vendor: nav.vendor,
    viewport: { width: Math.round(window.innerWidth), height: Math.round(window.innerHeight) },
    screen: { width: Math.round(window.screen.width), height: Math.round(window.screen.height) },
    devicePixelRatio: window.devicePixelRatio,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
